import React from 'react';
import NotFoundJpeg from '../../assets/images/not-found-404.jpg';
import { useHistory } from 'react-router-dom';

const NotFound404: React.FunctionComponent = (): JSX.Element => {
  const history = useHistory();
  const goBack = () => {
    history.goBack();
  };
  return (
    <div className="h-screen bg-white">
      <div className="w-full h-full flex justify-center">
        <div className="w-94 px-7.5 flex items-center">
          <div>
            <img src={NotFoundJpeg} alt="not-found" />
            <h3 className="text-blue font-bold text-center text-xl">Oops!</h3>
            <h3 className="text-dark-blue font-medium text-center text-xl mt-4">
              It looks like we’ve reached a wrong number.
            </h3>
            <h3 className="text-center text-blue font-medium text-xl mt-4">Error 404</h3>
            <button className="btn btn-blue h-11 w-full rounded-md font-bold mt-4" onClick={goBack}>
              GO BACK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default NotFound404;
